import {
  calculateMonthlyPrice,
  removeTrailingZeros,
} from '@forest/paywall-core'
import { useStore } from '@nanostores/solid'
import { createResource, Show } from 'solid-js'
import { productsReady } from '~/lib/message'
import { platform } from '~/lib/params'
import { m } from '~/paraglide/messages'
import { $chinaAndroidTrialEligibility } from '~/store'

export function DiscountSection() {
  const chinaAndroidTrialEligibility = useStore($chinaAndroidTrialEligibility)
  const [products] = createResource(() => productsReady.promise)

  const shouldHide = () =>
    platform === 'china_android' &&
    chinaAndroidTrialEligibility() === 'available'

  const percentOff = () => {
    const p = products()
    if (!p) return 0
    return Math.round(
      ((p.annualOriginal.price_value - p.annualEarlyBird.price_value) /
        p.annualOriginal.price_value) *
        100,
    )
  }

  const originalPrice = () => {
    const p = products()
    if (!p) return ''
    return removeTrailingZeros(p.annualOriginal.price_localized)
  }

  const earlyBirdPrice = () => {
    const p = products()
    if (!p) return ''
    return removeTrailingZeros(p.annualEarlyBird.price_localized)
  }

  const perMonthPrice = () => {
    const p = products()
    if (!p) return ''
    const monthlyPrice = calculateMonthlyPrice({
      price_localized: p.annualEarlyBird.price_localized,
      price_value: p.annualEarlyBird.price_value,
    })
    return m.onboarding_paywall_plan_price_in_month({
      discount_plan_price: monthlyPrice,
    })
  }

  return (
    <Show when={!shouldHide()}>
      <div class="flex w-full flex-col items-center gap-1">
        <Show when={products()}>
          <div class="flex h-[18px] items-center rounded-full bg-[#FAFF8E] px-3 text-xs font-bold text-[#001721]">
            {percentOff()}% off
          </div>
        </Show>
        <h2 class="w-full text-center text-[26px] font-bold text-[#FAFF8E]">
          {m.onboarding_paywall_early_bird_offer()}
        </h2>

        <div class="w-full">
          <div class="flex w-full items-center justify-center gap-2">
            <span class="text-lg text-white line-through opacity-50">
              {originalPrice()}
            </span>
            <span class="text-[36px] font-bold text-white">
              {earlyBirdPrice()}
            </span>
            <span class="text-lg font-semibold">
              {m.onboarding_paywall_plan_price({ plan_price: '' })}
            </span>
          </div>
          <p class="ml-auto w-10/12 text-center text-xs text-white/50">
            {perMonthPrice()}
          </p>
        </div>
      </div>
    </Show>
  )
}
